import { useState } from 'react';
import { client } from '@/utils/apiClients';
import { cookieUtils } from '@/utils/cookieUtils';
import { ENV } from '@/constant';
const BASE_URL = ENV.VITE_BASE_URL;
/**
 * Hook to handle profile updates (POST requests)
 * Replaces Redux updateProfile thunk with SWR mutation pattern
 */
export const useUpdateProfile = () => {
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);

    const updateProfile = async (body: any) => {
        setIsLoading(true);
        setError(null);

        try {

            const response = await client("/profile/update", {
                body: body,
            });


            if (response && response.success) {
                return response;
            } else {
                throw new Error('Failed to update profile');
            }
        } catch (error: any) {
            console.error('Error updating profile:', error);
            const errorMessage = error.message || 'Failed to update profile';
            setError(errorMessage);
            throw error;
        } finally {
            setIsLoading(false);
        }
    };

    return {
        updateProfile,
        isLoading,
        error,
    };
};



export const useUpdateDocument = () => {
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);

    const updateDocument = async (body: any) => {
        setIsLoading(true);
        setError(null);

        try {
            const response = await client("/documents/update", {
                body: body,
            });


            if (response && response.success) {
                return response;
            } else {
                throw new Error('Failed to update profile');
            }
        } catch (error: any) {
            console.error('Error updating profile:', error);
            const errorMessage = error.message || 'Failed to update profile';
            setError(errorMessage);
            throw error;
        } finally {
            setIsLoading(false);
        }
    };

    return {
        updateDocument,
        isLoading,
        error,
    };
};

export const uploadDocumentFile = () => {

    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);

    const uploadFile = async (file: File) => {
        setIsLoading(true);
        setError(null);
        // Get token from cookies
        const cookieToken = cookieUtils.getAuthToken();

        try {
            const formData = new FormData();
            formData.append('file', file);

            const response = await fetch(`${BASE_URL}/documents/upload`, {
                method: 'POST',
                body: formData,
                headers: {
                    "Authorization": `Bearer ${cookieToken}`,
                },
            });
            const result = await response.json();


            if (result && result.success) {
                return result;
            } else {
                throw new Error('Failed to upload file');
            }
        } catch (error: any) {
            console.error('Error uploading file:', error);
            const errorMessage = error.message || 'Failed to upload file';
            setError(errorMessage);
            throw error;
        } finally {
            setIsLoading(false);
        }
    }
    return {
        uploadFile,
        isLoading,
        error,
    };
}
